import * as fromDatatype from "../datatype-library";

export interface bl_fi_entity_sales_credit_limit_RowInterface {
  guid: fromDatatype.GuidDataFieldInterface;
  entity_credit_limit_guid: fromDatatype.GuidDataFieldInterface;
  credit_limit_code: fromDatatype.VarcharDatatypeInterface;
  credit_limit_name: fromDatatype.VarcharDatatypeInterface;
  entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
  descr: fromDatatype.VarcharDatatypeInterface;
  currency: fromDatatype.VarcharDatatypeInterface;
  amount: fromDatatype.NumericDatatypeInterface;
  created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
  created_date: fromDatatype.TimestampTzDatatypeInterface;
  updated_date: fromDatatype.TimestampTzDatatypeInterface;
  property_json: fromDatatype.JsonDatatypeInterface;
  status: fromDatatype.VarcharDatatypeInterface;
  revision: fromDatatype.GuidDataFieldInterface;
  vrsn: fromDatatype.VarcharDatatypeInterface;
  applet_guid: fromDatatype.GuidDataFieldInterface;
  module_guid: fromDatatype.GuidDataFieldInterface;
  acl_config: fromDatatype.JsonDatatypeInterface;
  acl_policy: fromDatatype.JsonDatatypeInterface;
}

export class bl_fi_entity_sales_credit_limit_RowClass
  implements bl_fi_entity_sales_credit_limit_RowInterface
{
    guid: fromDatatype.GuidDataFieldInterface;
    entity_credit_limit_guid: fromDatatype.GuidDataFieldInterface;
    credit_limit_code: fromDatatype.VarcharDatatypeInterface;
    credit_limit_name: fromDatatype.VarcharDatatypeInterface;
    entity_hdr_guid: fromDatatype.GuidDataFieldInterface;
    descr: fromDatatype.VarcharDatatypeInterface;
    currency: fromDatatype.VarcharDatatypeInterface;
    amount: fromDatatype.NumericDatatypeInterface;
    created_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    updated_by_subject_guid: fromDatatype.GuidDataFieldInterface;
    created_date: fromDatatype.TimestampTzDatatypeInterface;
    updated_date: fromDatatype.TimestampTzDatatypeInterface;
    property_json: fromDatatype.JsonDatatypeInterface;
    status: fromDatatype.VarcharDatatypeInterface;
    revision: fromDatatype.GuidDataFieldInterface;
    vrsn: fromDatatype.VarcharDatatypeInterface;
    applet_guid: fromDatatype.GuidDataFieldInterface;
    module_guid: fromDatatype.GuidDataFieldInterface;
    acl_config: fromDatatype.JsonDatatypeInterface;
    acl_policy: fromDatatype.JsonDatatypeInterface;
}
